/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_MinifyInputs */

const en_btn_minify = /** @type {(inputs: Btn_MinifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minify`)
};

const ko_btn_minify = /** @type {(inputs: Btn_MinifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`압축`)
};

const ja_btn_minify = /** @type {(inputs: Btn_MinifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮`)
};

/**
* | output |
* | --- |
* | "Minify" |
*
* @param {Btn_MinifyInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const btn_minify = /** @type {((inputs?: Btn_MinifyInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_MinifyInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_minify(inputs)
	if (locale === "ko") return ko_btn_minify(inputs)
	return ja_btn_minify(inputs)
});